import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

/**
 * Association — BPMN 2.0 dotted line connecting artifacts (TextAnnotation, Group)
 * to flow elements. Does not affect the flow.
 *
 * Supports associationDirection: None, One, Both.
 */

class AssociationView extends PolylineEdge {
  _getDirection() {
    const { model } = this.props;
    const props = model.properties || {};
    const direction = props.associationDirection || 'None';
    // Auto-detect compensation association (target has isForCompensation)
    if (direction === 'None' && props.isCompensation) return 'One';
    return direction;
  }

  getEndArrow() {
    const { model } = this.props;
    const direction = this._getDirection();

    if (direction === 'One' || direction === 'Both') {
      const { stroke } = model.getEdgeStyle();
      return h('path', {
        d: 'M 0 0 L 10 -5 L 10 5 Z',
        fill: 'none',
        stroke: stroke || '#555',
        strokeWidth: 1,
      });
    }
    return h('g', {});
  }

  getStartArrow() {
    const { model } = this.props;
    const direction = this._getDirection();

    if (direction === 'Both') {
      const { stroke } = model.getEdgeStyle();
      return h('path', {
        d: 'M 0 0 L -10 -5 L -10 5 Z',
        fill: 'none',
        stroke: stroke || '#555',
        strokeWidth: 1,
      });
    }
    return h('g', {});
  }
}

class AssociationModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, draggable: true };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'association');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.strokeDasharray = '4,4';
    return style;
  }

  getTextPosition() {
    const pos = super.getTextPosition();
    if (isNaN(pos.x) || isNaN(pos.y)) {
      return { x: 0, y: 0 };
    }
    return pos;
  }
}

export const Association = {
  type: 'epx:Association',
  view: AssociationView,
  model: AssociationModel,
};
